import { defineFeatures } from "../define-provider-capability";
import { tenantEnvironments, tenantResource } from "../firebase-tenant";

/**
 * The `firebase` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const firebaseMobileFeatures = defineFeatures({
  mobileAuthTenant: {
    scope: "deployment",
    environments: tenantEnvironments,
    resources: [tenantResource],
    env: [
      {
        name: "EXPO_PUBLIC_FIREBASE_AUTH_TENANT_ID",
        availability: "boot",
        mobileEasArtifact: "dotenv",
        source: {
          kind: "resourceOutput",
          resourceKey: "firebase-tenant",
          output: "FIREBASE_AUTH_TENANT_ID",
        },
      },
    ],
  },
  // Firebase JS SDK config blob baked into the mobile bundle.
  mobileConfig: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_FIREBASE_CONFIG",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "environment" },
      },
    ],
  },
});
